import type { EntityType } from '@tunasong/schemas'
import { dayjs } from '../time/dayjs-time.js'
import { capitalize } from './capitalize.js'

export const getDefaultEntityName = (entityType: EntityType): string => {
  const date = dayjs().format('lll')
  return `${capitalize(entityType)} ${date}`
}
